import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPpday70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_70: Record<
  Exclude<PageIdWoofzPpday70, PageIdWoofzPpday70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PPDAY_70_N]: {
    id: PageId.SUBSCRIPTIONS_PPDAY_70_N,
  },
  [PageId.CHAT_UPSELL_PPDAY_70]: {
    id: PageId.CHAT_UPSELL_PPDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PPDAY_70]: {
    id: PageId.UPSELL_PPDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_PPDAY_70]: {
    id: PageId.DOWNLOAD_PPDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
